export const BASE_URL= process.env.REACT_APP_BASEAPI_URL
// RON-5587: endpoints that must call v6 in every environment are pinned to this
// (same declaration as apiUtils.jsx).
export const API_V6 = process.env.REACT_APP_API_V6 ?? "v6/";

// LoginAPI Endpoints
export const GetLoginById_url = "v5/ReactLogin_api";
export const GetLoginByIdPassword_url = "v5/User/validation";
export const ManualLogin_url = "v5/User/login";
export const RedirectToUrl ="v5/User/selectLgnRegMethod"
export const Register_url ="v5/User/register"
export const ForgotPassword_url ="v5/User/forgotPassword"
export const ResetPassword_url ="v5/User/resetPassword"
export const validateResetPasswordToken_url = "v5/User/validateResetPasswordToken"
export const validateRegisterConfirmation_url = "v5/User/verifyUser"
export const originMismatch_url = "v5/access_denied/origin_mismatch"
export const CheckUserVehicle_url = "v5/CheckUserVehicle_api"

export const UserLogout_url = "v5/UserLogout_api"
// Token API Endpoint
export const GetRefreshToken_api = "v5/Token_api";

// Weekly-Calendar API Endpoints
export const GetWeeklyCalendar_url = `${API_V6}MyWeeklyBookings_api`; // RON-5587: pinned to v6
export const ZoneList_url = "v5/ZoneList_api";
export const MakeBooking_url = "v5.1/MakeBooking_api";
export const CancelBooking_url = "v5/CancelBooking_api";
export const MapGrid_api = `${API_V6}MapGrid_api`; // RON-5587: pinned to v6
export const MapCanvas_api = `${API_V6}MapCanvas_api`; // RON-5587: pinned to v6
export const GetParticipantsForMeeting_url = "v5/MeetingRoom_api/GetParticipantsForMeeting";
export const RescheduleMeeting_url = "v5/MeetingRoom_api/RescheduleMeeting";
export const MeetingRoomListAndInfo_url = "v5/MeetingRoom_api/MeetingRoomListAndInfo";
export const CreateNewMeeting_url = "v5/MeetingRoom_api/CreateNewMeeting";
// RON-5587: pinned to v6 (the response carries Records.AlternateZoneId)
export const ReportParkingViolation_url = `${API_V6}ReportParkingViolation_api`;
export const GetAlternateParkingSpot_url = `${API_V6}GetAlternateParkingSpot_api`;
export const CancelMeeting_url = "v5/MeetingRoom_api/CancelMeeting";
export const DeclineMeeting_url = "v5/MeetingRoom_api/DeclineMeeting";

// Notification API Endpoints
export const NotificationList_url = "v5/NotificationList_api";
export const NotificationToggleStatus_url = "v5/NotificationToggleStatus_api";
export const CheckInUser_url = "v5/CheckInUser_api";
export const MarkAsReadNotification_url = "v5/MarkAsReadNotification_api";
export const BookingConfirmation_url = "v5/BookingConfirmation_api";
export const ScheduledBookingConfirmation_url = "v5/ScheduledBookingConfirmation_api";
export const BookingStatus_url = "v5/MakeBooking_api/BookingStatus";

// Post-Booking Question API Endpoints
export const PostBookingQuestion_url = "v5/PostBookingQuestion_api";
export const PostBookingAnswer_url = "v5/PostBookingAnswer_api";
export const MapBasedBooking_apiBookingStatus_url = "v5.1/MapBasedBooking_api/BookingStatus"

// Home > My Bookings API Endpoints
export const HomeScreenBookings_url = "v5/HomeScreenBookings_api";
export const SearchBookings_url = "v5/SearchBookings_api";

// Home > My Inviatations API Endpoints
export const InvitationGuestBookings_url = "v5/InvitationGuestBookings_api";
export const CheckInForGuestUser_url = "v5/CheckInForGuestUser_api";
// RON-5587: pinned to v6 (the response carries Records.AlternateZoneId)
export const ReportParkingViolationForGuest_url = `${API_V6}ReportParkingViolationForGuest_api`;
export const GetAlternateParkingSpotForGuest_url = `${API_V6}GetAlternateParkingSpotForGuest_api`;

// Create New Booking API Endpoints
export const QuickBookingInfo_url = "v5/QuickBookingInfo_api";
export const SpotAvailability_url = "v5/SpotAvailability_api";
export const MapBasedBooking_url = "v5/MapBasedBooking_api";

// Profile API Endpoints
export const Profile_url = "v5/Profile_api";

// Setting > Need help? API Endpoints
export const Support_url = "v5/Support_api";

// Setting > Remove account API Endpoint
export const RemoveAccount_url = "v5/User/removeAccount";
